import { render, staticRenderFns } from "./BangTheTable.vue?vue&type=template&id=07e3328e"
import script from "./BangTheTable.vue?vue&type=script&lang=js"
export * from "./BangTheTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports